<template>
	<!-- 查看堂次 -->
	<div class="uni-exam-wrap examChurchOwn">
		<div class="uni-exam-pay">
			<div class="continer">
				<Title text="查看堂次"></Title>
				<div class="elTable">
					<!-- table -->
					<el-table slot="list" :data="dataList" headerRowClassName="uni-primary-table-header" stripe border>
						<!-- <el-table-column prop="exam_title" align="center" label="考试名称"></el-table-column> -->
						<el-table-column prop="exam_course_title" align="center" label="课程名称"></el-table-column>
						<el-table-column prop="exam_hall_start_time" align="center" label="考试时间" width="350">
							<template slot-scope="scope">
								{{ scope.row.exam_hall_start_time }} - {{ scope.row.exam_hall_end_time.split(' ')[1] }}
							</template>
						</el-table-column>
						<el-table-column prop="exam_type" align="center" label="考试类型">
							<template slot-scope="scope">
								{{ course[scope.row.exam_type].name }}
							</template>
						</el-table-column>
						<el-table-column align="center" label="考点">
							<template slot-scope="scope">
								<span @click="exam_address(scope.row)" v-if="_ENTRANCETYPE === 'own' && scope.row.exam_type == 2" class="address">
									{{ scope.row.exam_point_title }}
								</span>
							</template>
						</el-table-column>
						<el-table-column prop="exam_status_text" align="center" label="状态">
							<!-- <template slot-scope="scope">
								<span>{{ progressMap[(scope.row.exam_status)-1] }}</span>
							</template> -->
						</el-table-column>
						<el-table-column prop="score" align="center" label="成绩">
						</el-table-column>
						<!-- <el-table-column prop="created_at" align="center" label="考试要求">
							<template v-slot="scoped">
								<el-button type="text" @click="handleExamine(scoped.row)" v-if="scoped.row.exam_type === 1">[查看]</el-button>
								<span v-else>无</span>
							</template>
						</el-table-column> -->
						<el-table-column align="center" width="200" label="操作">
							<template slot-scope="scope">
								<!-- <el-button style="font-size: 12px" type="primary" @click="startExam(scope.row)">开始考试</el-button> -->
								<!-- 考试未开始 -->
								<!-- 判断 状态为待考试 状态是否为 线上考试 当前时间是否在考试时间内 -->
								<!-- <el-button style="font-size: 12px" type="primary" @click="startExam(scope.row)">开始考试</el-button> -->
                <el-button v-if="is_take_exam(scope.row)" size="small" style="font-size: 12px" type="primary" @click="startExam(scope.row)">开始考试</el-button>
<!--								<div v-if="is_take_exam(scope.row) || scope.row.is_sign_in == 1">-->
<!--									&lt;!&ndash; <span>{{ getEndTime[scope.$index] | formatTime }}</span> &ndash;&gt;-->
<!--									<el-button v-if="is_take_exam(scope.row)" size="small" style="font-size: 12px" type="primary" @click="startExam(scope.row)">开始考试</el-button>-->
<!--&lt;!&ndash;									<el-button v-if="scope.row.is_sign_in == 1" size="small" style="font-size: 12px" type="primary" @click="examSignIn(scope.row)">查看考签</el-button>&ndash;&gt;-->
<!--								</div>-->
								<!-- 考试截止 -->
								<!-- <el-button style="font-size: 12px" type="primary" v-else-if="scope.row.exam_status == 5" @click="examEnd(scope.row)">查看成绩</el-button> -->
								<span v-else>--</span>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>

			<!-- 考试要求
			<el-dialog :visible.sync="dialogVisible" width="30%">
				<div class="dialogContent">
					<div class="dialogContent-title">
						<h3>考试要求</h3>
						<div></div>
					</div>
					<div class="dialogContent-content">
						<div v-for="(value, index) in examRegist" :key="index">
							<span>{{ index + 1 }}</span>
							<em>{{ value }}</em>
						</div>
					</div>
				</div>
				<span slot="footer" class="dialog-footer"><el-button type="primary" @click="dialogVisible = false">知道了</el-button></span>
			</el-dialog> -->
			<el-dialog width="800px" title="地址" :visible.sync="examInfoVisible">
				<div class="dialog" style="padding: 0 0 10%">
					<el-table :data="[userInfo]" style="width: 100%">
						<el-table-column v-if="_ENTRANCETYPE === 'own'" prop="exam_point_title" label="考点"></el-table-column>
						<el-table-column prop="exam_room_teacher_sn" label="考室">
							<template slot-scope="{ row }">
								第{{ row.exam_room_teacher_sn }}考室
							</template>
						</el-table-column>
						<el-table-column prop="exam_room_title" label="教室"></el-table-column>
						<el-table-column prop="exam_room_seat_number" label="座位序号"></el-table-column>
						<el-table-column prop="exam_room_teacher_title" label="监考老师"></el-table-column>
						<el-table-column prop="exam_point_address" label="详细地址"></el-table-column>
					</el-table>
				</div>
				<span slot="footer" class="dialog-footer"><el-button type="primary" @click="examInfoVisible = false">知道了</el-button></span>
			</el-dialog>
		</div>
	</div>
</template>

<script>
import { getMyExams } from '@/api/exam';
import { mapState } from 'vuex';
export default {
	name: 'examChurchOwn',
	data() {
		return {
            exam_id: this.$route.query.id,
			courseModel: 0,
			course: [
				{ name: '全部', val: 0 },
				{ name: '线上考试', val: 1 },
				{ name: '线下考试', val: 2 },
				{ name: '模拟考试', val: 3 }
			],
			// progressModel: 0,
			dataList: [],
			examInfoVisible: false,
			examRegist: [],
			timer: [],
			getEndTime: [],
			userInfo: [],
			// progress: [
			// 	{ name: '全部', val: 0 },
			// 	// { name: "报名待审核", val: 1 },
			// 	// { name: "缴费审核失败", val: 2 },
			// 	{ name: '待考试', val: 2 },
			// 	{ name: '阅卷中', val: 3 },
			// 	{ name: '缺考', val: 4 },
			// 	{ name: '考试完成', val: 5 },
			// ],
			// progressMap: ['未缴费', '待考试', '阅卷中', '缺考', '考试完成', '考试中', '阅卷完成'],
			// dialogVisible: false,
		};
	},
	watch: {
		// isFace(val) {
		// 	if (!val) this.$refs['face'].sportsCamera();
		// }
	},
	computed: {
		...mapState('common', {
			studentMajor: state => state.studentMajor
		}),
		...mapState('permission', {
			_ENTRANCETYPE: state => state._ENTRANCETYPE
		})

	},
	mounted() {
		this.getData();
	},
	beforeDestroy() {
		// 清除定时器
		if (this.timer.length > 0) {
			this.timer.forEach(timer => {
				if (timer) {
					clearInterval(timer);
				}
			});
		}
	},
	methods: {
		// 点击 查看考签
		examSignIn(row){
			this.$router.push({
				name: 'examSignInOwn',
				query: {
					id: row.id,
				},
			})
		},
		exam_address(row) {
			this.userInfo = row;
			this.examInfoVisible = true;
		},
		//判断当前时间是否在时区里
		isDuringDate(beginDateStr, endDateStr) {
			var curDate = new Date().getTime(),
				beginDate = new Date(beginDateStr.replace(/-/g,"/")).getTime(),
				endDate = new Date(endDateStr.replace(/-/g,"/")).getTime();
			if (curDate >= beginDate && curDate <= endDate) {
				return true;
			}
			return false;
		},
		// 我的考试
		async getData() {
			let params = {
                exam_id: this.exam_id
            };

			const { result } = await getMyExams(params);

			if (result) {
				this.dataList = result.list || result;
				// console.log(this.dataList);
				// // 设置考试倒计时定时器
				// this.getTimer(result.list);
			}
		},
		// 开始考试
		startExam(data) {
			// console.log(data);
			// // 屏蔽人脸摄像头验证
			this.$router.push({
				name: 'examDetailsOwn',
				query: {
					examId: data.id
				}
			});
		},
		//考试状态 判断是否 可以考试
		is_take_exam(row){
			// && row.is_open_book == 0
			if((row.exam_status == 2 || row.exam_status == 6) && (row.exam_type == 1 || row.exam_type == 3) && this.isDuringDate(row.exam_hall_start_time,row.exam_hall_end_time)){
				return true;
			}
			return false;
		},
	}
};
</script>

<style lang="scss" scoped>
.uni-exam-wrap {
	min-height: $contentH;
	padding: $sideMargin;
	padding-bottom: 0;
}
.uni-exam-pay {
	min-height: inherit;
	background: #fff;

	.divider {
		width: 100%;
		height: 1px;
		background-color: #e9edf7;
	}
	.elTable {
		width: 100%;
		overflow: hidden;
	}
	.continer {
		height: 100%;
		//overflow: hidden;
		padding: 0 20px 20px;
	}

	.filter-box {
		.tit {
			font-size: 16px;
			font-weight: 600;
			margin-right: 20px;
		}

		.btn-box {
			padding: 0 20px;
			height: 30px;
		}

		.filter-list {
			.item {
				display: flex;
				align-items: center;
				padding: 0 20px;
				margin-bottom: 20px;

				&:last-child {
					border: none;
				}
			}
		}

		.select-btn {
			width: 75px;
			height: 25px;
			padding: 0;
		}
	}

	.opera-btn {
		width: 75px;
		height: 25px;
		padding: 0;
		font-size: 12px;
	}

	.link {
		color: $primary;
		cursor: pointer;
	}

	.typeColor1 {
		color: #999999;
	}

	.typeColor2 {
		@include fontColor('primary');
	}
	.dialogContent {
		padding: 0 60px;
		.dialogContent-title {
			position: relative;
			height: 30px;
			h3 {
				font-weight: 400;
				font-size: 20px;
				color: #343434;
				position: absolute;
				left: 50%;
				transform: translateX(-50%);
				z-index: 10;
			}
			div {
				height: 13px;
				width: 100px;
				background-color: #b2c1ff;
				position: absolute;
				left: 50%;
				transform: translateX(-50%);
				top: 80%;
			}
		}
		.dialogContent-content {
			margin-top: 20px;
			div {
				padding: 5px 0;
				display: flex;
				span {
					margin-right: 5px;
				}
			}
		}
	}
	/deep/ .el-dialog__footer {
		text-align: center;
	}
	.address {
		color: blue;
		cursor: pointer;
		text-decoration: underline;
	}
}
</style>
